import { ReactNode } from 'react';

import { Typography } from '@material-ui/core';

import { getComplementaryColorByString } from '../../utils';

export const stringAvatar = (
  firstName: string,
  imageUrl?: string,
): { style: Record<string, unknown>; children: ReactNode } => {
  return {
    style: {
      backgroundColor: getComplementaryColorByString(firstName),
    },
    children: !imageUrl && <Typography variant="h5">{firstName ? firstName[0].toUpperCase() : ''}</Typography>,
  };
};
